/* eslint-disable no-inner-declarations */
import React, { useEffect, useState } from 'react';
import s from './InfoMsg.scss';

export const positions = { CENTER: 0, LEFT: 1, RIGHT: 2 };
export const sizes = { SMALL: 'small', MEDIUM: 'medium', LARGE: 'large' };

const InfoMsg = ({
  msg,
  position = positions.CENTER,
  customClass,
  size,
  NewUIInfoMsg = false,
  isMobile,
  hideShow,
}) => {
  const [open, setOpen] = useState(hideShow);

  useEffect(
    () => {
      setOpen(hideShow);
    },
    [hideShow],
  );

  // eslint-disable-next-line consistent-return

  return (
    <div
      className={`${s.infomsg} ${position === 2 ? s.right : ''} ${
        size ? s[size] : ''
      } ${NewUIInfoMsg ? s.NewUIInfoMsg : ''} ${customClass || ''}`}
    >
      <i
        className={s.icon}
        onClick={e => {
          e.stopPropagation(); // Prevent click outside handler
          setOpen(prev => !prev);
        }}
      />
      {!isMobile && <span>{msg}</span>}
      {open && isMobile && <span>{msg}</span>}
    </div>
  );
};
export default InfoMsg;
